module.exports = __webpack_public_path__ + "media/success.12ba0ad1.mp3";